const INTERNAL_KEY = "bgb_internal";
const INTERNAL_PARAM = "internal";

function safeStorage(): Storage | null {
  try {
    return globalThis.localStorage ?? null;
  } catch {
    return null;
  }
}

/**
 * Marks the browser as an internal/test account when the page is opened with
 * `?internal=1` once; the flag persists in localStorage and is sent as the
 * `internal` person property so PostHog's test-account filter can exclude it.
 * `?internal=0` clears the flag.
 */
export function resolveInternalFlag(
  search: string,
  storage: Pick<Storage, "getItem" | "setItem" | "removeItem"> | null = safeStorage(),
): boolean {
  const param = new URLSearchParams(search).get(INTERNAL_PARAM);
  if (param === "1") {
    storage?.setItem(INTERNAL_KEY, "1");
    return true;
  }
  if (param === "0") {
    storage?.removeItem(INTERNAL_KEY);
    return false;
  }
  return storage?.getItem(INTERNAL_KEY) === "1";
}
